import React, { useEffect, useState } from "react";
import { Container, Button, Form, Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const OrgRegisterScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [isGroup, setIsGroup] = useState(false);
    const [ctFullName, setCtFullName] = useState('');
    const [ctPosition, setCtPosition] = useState('');
    const [ctPhone, setCtPhone] = useState('');
    const [ctEmail, setCtEmail] = useState('');
    const [orgName, setOrgName] = useState('');
    const [orgAddress, setOrgAddress] = useState('');
    const [orgSchools, setOrgSchools] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [tcsChecked, setTcsChecked] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if ( password !== confirmPassword ) {
            setPassword("");
            setConfirmPassword("");
            window.alert("Passwords do not match.");
            return;
        }

        if ( password.length < 6 ) {
            setPassword("");
            setConfirmPassword("");
            window.alert("Password must be at least 6 characters long.");
            return;
        }

        navigate('/org-checkout', {
            state: {
                username,
                password,
                isGroup,
                ctFullName,
                ctPosition,
                ctPhone,
                ctEmail,
                orgName,
                orgAddress,
                orgSchools,
            }
        });
    }
    
    return (
        <Container className="page-shell">
        <section className="page-header">
            <h3 className="page-title">Enter Organisation Details</h3>
            <p className="page-subtitle fst-italic">
                We register your organisation account only after payment success, so please confirm all details carefully.
            </p>
        </section>
        <Card>
        <Card.Body>
        <Form onSubmit={handleSubmit}>

            <div className="fw-bold">
                Registration Steps
                <ol className="content-list mt-3">
                    <li>Complete the registration form below, and click "Confirm Details and Pay"</li>
                    <li>Enter your payment details, and click "Pay Now"</li>
                    <li>Once the payment is successful, we will send you an email asking for verification. Click on the verification link.</li>
                    <li>Once verified, you will be able to login and start using the platform.</li>
                </ol>
            </div>
            <Row className="mt-3">
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formUsername">
                        <Form.Label>Account Username</Form.Label>
                        <Form.Control required placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} tabIndex={1}/>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formCtFullName">
                        <Form.Label>Contact Full Name</Form.Label>
                        <Form.Control required placeholder="Contact full name" value={ctFullName} onChange={(e) => setCtFullName(e.target.value)} tabIndex={5}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" required autoComplete="true" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} tabIndex={2}/>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formConfirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control type="password" required autoComplete="true" placeholder="Confirm password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} tabIndex={3}/>
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group className="mb-3" controlId="formGroup">
                <Form.Check type="checkbox" label="This account manages multiple schools" checked={isGroup} onChange={(e) => setIsGroup(e.target.checked)} tabIndex={4}/>
            </Form.Group>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formCtPosition">
                        <Form.Label>Contact Position</Form.Label>
                        <Form.Control required placeholder="Contact position" value={ctPosition} onChange={(e) => setCtPosition(e.target.value)} tabIndex={6}/>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formCtPhone">
                        <Form.Label>Contact Phone</Form.Label>
                        <Form.Control required placeholder="Contact phone" value={ctPhone} onChange={(e) => setCtPhone(e.target.value)} tabIndex={7}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formCtEmail">
                        <Form.Label>Contact Email</Form.Label>
                        <Form.Control type="email" required placeholder="Contact email" value={ctEmail} onChange={(e) => setCtEmail(e.target.value)} tabIndex={8}/>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formOrgName">
                        <Form.Label>Organisation Name</Form.Label>
                        <Form.Control required placeholder="Organisation name" value={orgName} onChange={(e) => setOrgName(e.target.value)} tabIndex={9}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3" controlId="formOrgAddress">
                        <Form.Label>Organisation Address</Form.Label>
                        <Form.Control required placeholder="Organisation address" value={orgAddress} onChange={(e) => setOrgAddress(e.target.value)} tabIndex={10}/>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-4" controlId="formOrgSchools">
                        <Form.Label>Schools List (if multiple)</Form.Label>
                        <Form.Control placeholder="School 1, School 2, School 3" value={orgSchools} onChange={(e) => setOrgSchools(e.target.value)} tabIndex={11}/>
                    </Form.Group>
                </Col>
            </Row>
            <Form.Group className="mb-3" controlId="formTermsAndConditions">
                <Form.Check type="checkbox" label={
                <span>
                    I agree to the{' '}
                    <Link to="/org-terms-and-conditions" target="_blank">Terms and Conditions</Link>
                </span>} checked={tcsChecked} onChange={(e) => setTcsChecked(e.target.checked)} tabIndex={12}/>
            </Form.Group>
            <Button variant="primary" type="submit" tabIndex={13} disabled={!tcsChecked}>Confirm Details and Pay</Button>
        </Form>
        </Card.Body>
        </Card>
        </Container>
    );
}

export default OrgRegisterScreen;